<template>
	<el-container>
		<el-main>
			<div style="margin-bottom: 30px;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">开口机器人</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">自动评估</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="top1">
				<div class="dataShow">
					<div class="con"><div>评估时间：</div> <div class="data">{{form.assessmentTime}}</div></div>
					<div class="con"><div>总共：</div><div class="data">{{form.corpusTotal}}条</div></div>
					<div class="con"><div>通过：</div><div class="data">{{form.passTotal}}条</div></div>
					<div class="con"><div>存疑：</div><div class="data">{{form.doubTotal}}条</div></div>
				</div>
				<div style="margin-bottom: 25px;height: 50px;text-align: right;" class="item_font">
					<el-button type="primary" size="mini" v-if="status===1 || status==='1' || status===0 || status==='0'" @click="clickEstimate" class="item_font">评估</el-button>
					<el-button type="info" size="mini" v-if="status==2 || status==='2'" disabled class="item_font">正在评估</el-button>
					<el-button type="info" size="mini" v-if="status==3 || status==='3' || status===4 || status==='4'" disabled class="item_font">评估完成</el-button>
					<el-button type="primary" size="mini" v-if="status==2 || status==='2'" @click="refresh" class="item_font">刷新</el-button>
				</div>
			</div>
			<div style="width: 90%;height: 550px;" class="item_font">
				<el-table stripe :data="form.corpusTalkEsExtendVoList" border highlight-current-row style="width: 100%" :header-cell-style="headerStyle" :cell-style="cellStyle">
					<el-table-column  property="query" label="问句">
					</el-table-column>
					<el-table-column property="topicName" label="匹配">
					</el-table-column>
					<el-table-column property="score" label="匹配度" width="200">
					</el-table-column>
				</el-table>
			</div>
		</el-main>
		<el-footer>
			<div style="display: flex;flex-direction: row;width: 60%;margin-left: 20%;justify-content: space-around;">
				<el-pagination background :pager-count='9' :page-size="100"  layout="prev, pager, next, total"  :total="total" @prev-click="pre" @next-click="next" @current-change="handleCurrentChange"> </el-pagination>
			</div>
		</el-footer>
	</el-container>
</template>

<script>
	export default {
		name: 'estimate',
		data() {
			return {
				status: 1,
				userId:this.util.getLocalAccount().id,
				myHeaders:{Authorization:localStorage.getItem("token")},
				form: {
					assessmentTime: 0,
					corpusTotal: 0,
					passTotal: 0,
					doubTotal:0,
					corpusTalkEsExtendVoList:[],
				},
				page:1,
				total:0
			}
		},
		mounted(){
			this.statusSelect()
			this.timer = setInterval(this.statusSelect, 10000);
			console.log(this.userId)
		},
		beforeDestroy(){
			clearInterval(this.timer);
		},
		methods: {
			headerStyle() {
				return 'text-align:left;padding:15px;color:#000000;'
			},
			cellStyle({columnIndex}) {
				if(columnIndex===2){
					return 'text-align:left;padding:15px;color:#55aaff;'
				}else{
					return 'text-align:left;padding:15px;'
				}
			},
			// 状态查询
			async statusSelect() {
				// 状态查询
				// status状态：0未开始 1编辑状态 2评估中 3已评估未发布 4已发布
				var api = "/manager/talkCorpus/publishCount";
				const response =await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
					},
					itype:"1"
				});
				console.log("*****statusSelect *****", response);
				this.status = response.data.aiModelVo.status
				this.estimateCallback()
				if(this.status===3 || this.status==='3' || this.status===4 || this.status==='4' ){
					// 评估完成对定时器进行销毁
					clearInterval(this.timer);
				}
			},
			
			async estimate() {
				// 评估
				var api = "/manager/talkCorpus/talkAssessment";
				const response =await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						createId:this.userId
					},
					itype:"1"
				});
				console.log("*****estimate *****", response);
				this.statusSelect()
			},
			
			async estimateCallback() {
				// 评估回调获取数据
				var api = "/manager/talkCorpus/talkAssessCallBack";
				const response =await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						current:this.page,
						size:100
					},
					itype:"1"
				});
				console.log("*****estimateCallback *****", response);
				this.form=response.data
				this.total=response.data.doubTotal
				console.log("this.total===>",this.total)
			},
			
			clickEstimate() {
				this.estimate()
			},
			refresh() {
				this.statusSelect()
			},
			pre(info) {
				console.log("pre：",info)
				this.page = info
				this.estimateCallback()
			},
			next(info) {
				console.log("next：",info)
				this.page = info
				this.estimateCallback()
			},
			handleCurrentChange(info) {
				console.log("当前页码：",info)
				this.page = info
				this.estimateCallback()
			},
		}
	}
</script>

<style>
	.top1 {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		/* margin-top: 15px; */
		width: 90%;
	}
	.dataShow{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		width: 70%;
		font-size: 15px;
		margin-bottom: 30px;
		@include change_size($font_size_normal)
	}
	.data {
		color: #409EFF;
		height: 50px;
		line-height: 22px;
	}
	.con{
		display: flex;
		height: 25px;
		@include change_size($font_size_normal)
	}
</style>
